import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, Fragment as _Fragment, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "p-4 h-full overflow-auto flex flex-col" }
const _hoisted_2 = {
  key: 1,
  class: "flex items-center justify-between mb-3"
}
const _hoisted_3 = {
  key: 0,
  class: "text-14px text-black-lp-300"
}
const _hoisted_4 = {
  key: 1,
  class: "ml-auto"
}
const _hoisted_5 = {
  key: 2,
  class: "overflow-auto flex-1 text-14px"
}
const _hoisted_6 = {
  key: 0,
  class: "flex items-center gap-2"
}
const _hoisted_7 = { key: 1 }
const _hoisted_8 = {
  key: 0,
  class: "flex items-center gap-2"
}
const _hoisted_9 = { key: 0 }
const _hoisted_10 = {
  key: 1,
  class: "flex flex-col"
}
const _hoisted_11 = { class: "text-black-lp-300 font-semibold line-clamp-2 w-50" }
const _hoisted_12 = { class: "flex flex-row items-center gap-1" }
const _hoisted_13 = { class: "text-12px text-gray-lp-300" }
const _hoisted_14 = {
  key: 1,
  class: "whitespace-nowrap"
}
const _hoisted_15 = {
  key: 2,
  "data-testid": "pickup-dashboard-row-total-shipment"
}
const _hoisted_16 = { key: 0 }
const _hoisted_17 = {
  key: 5,
  class: "flex items-center justify-center w-full"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_LpButton = _resolveComponent("LpButton")!
  const _component_TableDetail = _resolveComponent("TableDetail")!
  const _component_TransferPickupModal = _resolveComponent("TransferPickupModal")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      (_ctx.error)
        ? (_openBlock(), _createBlock(_component_ErrorMessage, {
            key: 0,
            errorType: 'internal-server-error',
            onTryAgain: _ctx.fetchData,
            textButtonSuccess: _ctx.$t('pickupDashboard.tryAgain')
          }, null, 8, ["onTryAgain", "textButtonSuccess"]))
        : (_openBlock(), _createBlock("div", _hoisted_2, [
            (_ctx.selectedCount > 0)
              ? (_openBlock(), _createBlock("div", _hoisted_3, _toDisplayString(_ctx.selectedCount) + " " + _toDisplayString(_ctx.$t("pickupDashboard.selectedSender")), 1))
              : _createCommentVNode("", true),
            (_ctx.selectedCount > 0)
              ? (_openBlock(), _createBlock("div", _hoisted_4, [
                  _createVNode(_component_LpButton, {
                    title: _ctx.$t('pickupDashboard.transferPickUp'),
                    color: "red-lp-100",
                    textColor: "white",
                    onClick: _ctx.onBulkTransferPickUp,
                    iconLeft: `transfer-list-white`
                  }, null, 8, ["title", "onClick"])
                ]))
              : _createCommentVNode("", true)
          ])),
      (!_ctx.error)
        ? (_openBlock(), _createBlock("div", _hoisted_5, [
            _createVNode(_component_TableDetail, {
              columns: _ctx.columns,
              data: _ctx.pagedData,
              isLoading: _ctx.isLoading,
              sortBy: _ctx.sortBy,
              sortDir: _ctx.sortDir,
              startIndex: _ctx.startIndex,
              pagination: _ctx.pagination,
              "onUpdate:pagination": _cache[1] || (_cache[1] = ($event: any) => (_ctx.pagination = $event)),
              renderedData: _ctx.pagedData.length,
              isFiltering: _ctx.isFiltering,
              onSetPage: _ctx.onSetPage,
              onSort: _ctx.onSort,
              onRowTransfer: _ctx.onTransferPickUpRow,
              onSelectToggle: _ctx.onSelectToggle,
              onToggleSelectAll: _ctx.onToggleSelectAll
            }, {
              head: _withCtx(({ col, sortBy, sortDir }) => [
                (col.key === 'total_shipment')
                  ? (_openBlock(), _createBlock("div", _hoisted_6, [
                      _createVNode("span", null, _toDisplayString(_ctx.$t("pickupDashboard.column.totalShipment")), 1),
                      (sortBy === (col.sortingKey || col.key) && sortDir === 'asc')
                        ? (_openBlock(), _createBlock("img", {
                            key: 0,
                            src: require('@/app/ui/assets/svg/ics_o_chevron_sort_asc.svg'),
                            class: "w-4 h-4",
                            alt: "sort-asc"
                          }, null, 8, ["src"]))
                        : (
                sortBy === (col.sortingKey || col.key) && sortDir === 'desc'
              )
                          ? (_openBlock(), _createBlock("img", {
                              key: 1,
                              src: require('@/app/ui/assets/svg/ics_o_chevron_sort_desc.svg'),
                              class: "w-4 h-4",
                              alt: "sort-desc"
                            }, null, 8, ["src"]))
                          : (_openBlock(), _createBlock("img", {
                              key: 2,
                              src: require('@/app/ui/assets/svg/ics_o_chevron_sort.svg'),
                              class: "w-4 h-4",
                              alt: "sort"
                            }, null, 8, ["src"]))
                    ]))
                  : (_openBlock(), _createBlock("span", _hoisted_7, _toDisplayString(_ctx.$t(col.name || col.label)), 1))
              ]),
              cell: _withCtx(({ item, col }) => [
                (col.key === 'sender_name')
                  ? (_openBlock(), _createBlock("div", _hoisted_8, [
                      (!item.sender_name)
                        ? (_openBlock(), _createBlock("div", _hoisted_9, "-"))
                        : (_openBlock(), _createBlock("div", _hoisted_10, [
                            _createVNode("div", _hoisted_11, _toDisplayString(_ctx.ellipsis(item.sender_name)), 1),
                            _createVNode("div", _hoisted_12, [
                              _createVNode("div", _hoisted_13, _toDisplayString(_ctx.formatPhoneNumber(item.sender_phone)), 1),
                              _createVNode("img", {
                                src: 
                      require('@/app/ui/assets/svg/ics_o_whatsapp-background.svg')
                    ,
                                class: "w-4 h-4 cursor-pointer",
                                alt: "whatsapp",
                                onClick: ($event: any) => (_ctx.onOpenWa(item.sender_phone))
                              }, null, 8, ["src", "onClick"])
                            ])
                          ]))
                    ]))
                  : (col.key === 'shipment_type')
                    ? (_openBlock(), _createBlock("span", _hoisted_14, _toDisplayString(_ctx.formatShipmentType(item.shipment_type)), 1))
                    : (col.key === 'total_shipment')
                      ? (_openBlock(), _createBlock("span", _hoisted_15, _toDisplayString(_ctx.fmtQty(item.total_shipment)) + " (" + _toDisplayString(_ctx.fmtQty(item.total_quantity)) + ")", 1))
                      : (col.key === 'expired_at')
                        ? (_openBlock(), _createBlock("span", {
                            key: 3,
                            class: ["whitespace-nowrap", 
                _ctx.remainingSeconds(item) < 1800
                  ? 'text-red-lp-100 font-semibold bg-pink-lp-200 px-2 rounded'
                  : 'text-black-lp-300 bg-gray-lp-1000 px-2 rounded'
              ]
                          }, _toDisplayString(_ctx.formatRemaining(_ctx.remainingSeconds(item))), 3))
                        : (col.key === 'sender_address')
                          ? (_openBlock(), _createBlock(_Fragment, { key: 4 }, [
                              (!item.sender_address)
                                ? (_openBlock(), _createBlock("div", _hoisted_16, "-"))
                                : (_openBlock(), _createBlock("a", {
                                    key: 1,
                                    href: _ctx.mapsHref(item),
                                    target: "_blank",
                                    class: "text-red-lp-100 underline line-clamp-2 w-40"
                                  }, _toDisplayString(_ctx.ellipsis(item.sender_address)), 9, ["href"]))
                            ], 64))
                          : (col.key === 'actionable_column')
                            ? (_openBlock(), _createBlock("div", _hoisted_17, [
                                _createVNode("img", {
                                  src: require('@/app/ui/assets/svg/transfer-list.svg'),
                                  class: "w-5 h-5 cursor-pointer",
                                  alt: "transfer",
                                  onClick: ($event: any) => (_ctx.onTransferPickUpRow(item))
                                }, null, 8, ["src", "onClick"])
                              ]))
                            : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["columns", "data", "isLoading", "sortBy", "sortDir", "startIndex", "pagination", "renderedData", "isFiltering", "onSetPage", "onSort", "onRowTransfer", "onSelectToggle", "onToggleSelectAll"])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_TransferPickupModal, {
      show: _ctx.showTransferModal,
      selectedSellers: _ctx.selectedSellersForTransfer,
      sourceCourierId: _ctx.courierId,
      "onUpdate:show": _cache[2] || (_cache[2] = ($event: any) => (_ctx.showTransferModal = $event)),
      onRemoveSeller: _ctx.onRemoveSellerFromTransfer,
      onTransferSuccess: _ctx.onTransferSuccess
    }, null, 8, ["show", "selectedSellers", "sourceCourierId", "onRemoveSeller", "onTransferSuccess"])
  ], 64))
}